// extracted by mini-css-extract-plugin
export default {"modal-body":"offerCard_modal-body__vm0YX","active-day":"offerCard_active-day__cQIKY","slots-area":"offerCard_slots-area__kpmp1","blockMessage":"offerCard_blockMessage__kAojR"};